import type { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';
import { useInfiniteQuery } from '@tanstack/react-query';

import { useAppState } from '../../../AppStateProvider';
import type { Contact } from '../../../domain/contact';
import { useCompanyQuery } from '../../company/useCompanyQuery';
import { contactsApi } from '../api';

import { makeContactListQueryKey } from './contactListQueryKey';

const CONTACTS_PER_PAGE = 20;

export const useContactListQuery = (): UseInfiniteQueryResult<InfiniteData<Contact[]>> => {
  const appState = useAppState();
  const { companyLinkedinId, contactFilters } = appState;
  const { domain } = useCompanyQuery().data || {};
  const { includeCountries, contactDetails, status } = contactFilters;

  return useInfiniteQuery({
    queryKey: makeContactListQueryKey({ companyLinkedinId, domain, contactFilters }),
    queryFn: ({ queryKey: [, linkedinId, domain, searchText, persona], pageParam }) => {
      return contactsApi.getContacts({
        linkedinId,
        domain,
        page: pageParam,
        perPage: CONTACTS_PER_PAGE,
        searchText,
        persona,
        includeCountries,
        contactDetails,
        status,
      });
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, pages) => (lastPage.length === CONTACTS_PER_PAGE ? pages.length : undefined),
    enabled: !!domain,
  });
};
